import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXCMAInquiryThankYou implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxCMAInquiryThankYouContainer";
    }
    render(){
        // console.log("thank you");

    }
}